"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uppercaseString = void 0;
exports.uppercaseString = (str = "") => {
    return str.toUpperCase().trim();
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/util/uppercase-string.ts
// module id = 255
// module chunks = 0